/* eslint-disable react/function-component-definition */
import {
    createTheme,
    CssBaseline,
    ThemeProvider,
    Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { useState } from 'react';
import {
    BrowserRouter as Router, Route, Switch, useHistory,
} from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import Snackbar from '../components/Snackbar';
import Home from '../Home';
import Carga from '../pages/CargaArchivos/Carga';
import Clientes from '../pages/Clientes/Clientes';
import Bancos from '../pages/Bancos/Bancos';
import CuentasBancarias from '../pages/CuentasBancarias/CuentasBancarias';
import MovimientosBancarios from '../pages/MovimientosBancarios/MovimientosBancarios';
import ClasificacionMovimientos from '../pages/ClasificacionMovimientos/ClasificacionMovimientos';
import GenericParameters from '../pages/GenericParameters/GenericParameters';
import ControlIngresos from '../pages/ControlIngresos/ControlIngresos';
import Gasolina from '../pages/Gasolina/Gasolina';
import Casetas from '../pages/Casetas_New/Casetas_New';
import Operators from '../pages/Operators/Operators';
import Unidades from '../pages/Unidades/Unidades';
import Facturas from '../pages/Facturas/Facturas';
import GPS from '../pages/GPS/GPS';
import Viaje from '../pages/Viaje/Viaje';
import Viajes from '../pages/Viajes/Viajes';
import LiquidacionOperadores from '../pages/liquidacion/Operadores';
import LiquidacionViajes from '../pages/liquidacion/Viajes';
import Usuarios from '../pages/usuarios/usuarios';
import DescuentoOperador from '../pages/Operators/DescuentoOperador';
import Referenciados from '../pages/liquidacion/Referenciados';
import Admin from '../pages/usuarios/Admin';
import Pagos from '../pages/Operators/Pagos';
import LiquidacionAdmin from '../pages/liquidacion/Admin';
import PagosAdmin from '../pages/Operators/PagosAdmin';
import { ReporteUtilidad } from '../pages/Reportes/ReporteUtilidad';
import { GastosExtra } from '../pages/gastosextra/GastosExtra';
import Ubicaciones from '../pages/Ubicaciones/Ubicaciones';
import Monitoreo from '../pages/Monitoreo/Monitoreo';
import Mantenimiento from '../pages/Mantenimiento/Mantenimiento';
import Password from '../pages/Password/Password';
import RegistroMateriales from '../pages/RegistroMateriales/RegistroMateriales';
import HistorialMtto from '../pages/HistorialMtto/HistorialMtto';
import ReporteMtto from '../pages/Reportes_mtto/Reporte_mtto';

const ProtectedRoute = ({ children, ...rest }) => {
    const auth = useAuth();
    if (auth.isLoading) {
        return <div>Loading...</div>;
    }
    if (auth.error) {
        return (
            <div>
                Error:
                {auth.error.message}
            </div>
        );
    }
    if (!auth.isAuthenticated) {
        auth.signinRedirect();
        return <div>Redirecting to login...</div>;
    }
    return <Route {...rest}>{children}</Route>;
};

const useStyles = makeStyles({
    appMain: {
        paddingLeft: ' 0px',
        width: '100%',
        display: 'flex',
    },
});
const theme = createTheme({
    palette: {
        primary: {
            main: '#333996',
            light: '#3c44b126',
        },
        secondary: {
            main: '#f83245',
            light: '#f8324526',
        },
        background: {
            default: '#f4f5fd',
        },
    },
    overrides: {
        MuiAppBar: {
            root: {
                transform: 'translateZ(0)',
            },
        },
    },
    props: {
        MuiIconButton: {
            disableRipple: true,
        },
    },
});

export default function App() {
    const classes = useStyles();
    const [clickOnViaje, setClickOnViaje] = useState(true);

    return (

        <>
            <ThemeProvider theme={theme}>
                <div className={classes.appMain}>

                    <SideMenu />

                    <Grid container spacing={3}>
                        <Snackbar />
                        <Grid item xs={12}>
                            <Header />
                        </Grid>
                        <Grid item xs={12}>
                            <Switch>
                                <ProtectedRoute path='/operadores/:operadorId'>
                                    <DescuentoOperador />
                                </ProtectedRoute>
                                <ProtectedRoute path='/operadores'>
                                    <Operators />
                                </ProtectedRoute>
                                <ProtectedRoute path='/unidades'>
                                    <Unidades />
                                </ProtectedRoute>
                                <ProtectedRoute path='/clientes'>
                                    <Clientes />
                                </ProtectedRoute>
                                <ProtectedRoute path='/bancos'>
                                    <Bancos />
                                </ProtectedRoute>
                                <ProtectedRoute path='/cuentas-bancarias'>
                                    <CuentasBancarias />
                                </ProtectedRoute>
                                <ProtectedRoute path='/movimientos-bancarios'>
                                    <MovimientosBancarios />
                                </ProtectedRoute>
                                <ProtectedRoute path='/clasificacion-movimientos'>
                                    <ClasificacionMovimientos />
                                </ProtectedRoute>
                                <ProtectedRoute path='/generic-parameters'>
                                    <GenericParameters />
                                </ProtectedRoute>
                                <ProtectedRoute path='/control-ingresos'>
                                    <ControlIngresos />
                                </ProtectedRoute>
                                <ProtectedRoute path='/ubicaciones'>
                                    <Ubicaciones />
                                </ProtectedRoute>
                                <ProtectedRoute path='/monitoreo'>
                                    <Monitoreo />
                                </ProtectedRoute>
                                <ProtectedRoute path='/viajes'>
                                    <Viajes />
                                </ProtectedRoute>
                                <ProtectedRoute path='/viaje/:viajeId'>
                                    <Viaje />
                                </ProtectedRoute>
                                <ProtectedRoute path='/viaje'>
                                    <Viaje />
                                </ProtectedRoute>
                                <ProtectedRoute path='/carga'>
                                    <Carga />
                                </ProtectedRoute>
                                <ProtectedRoute path='/gasolina'>
                                    <Gasolina />
                                </ProtectedRoute>
                                <ProtectedRoute path='/gps'>
                                    <GPS />
                                </ProtectedRoute>
                                <ProtectedRoute path='/casetas'>
                                    <Casetas />
                                </ProtectedRoute>
                                <ProtectedRoute path='/liquidacionop'>
                                    <LiquidacionOperadores />
                                </ProtectedRoute>
                                <ProtectedRoute path='/liquidacionvi'>
                                    <LiquidacionViajes />
                                </ProtectedRoute>
                                <ProtectedRoute path='/facturas'>
                                    <Facturas />
                                </ProtectedRoute>
                                <ProtectedRoute path='/usuarios'>
                                    <Usuarios />
                                </ProtectedRoute>
                                <ProtectedRoute path='/referenciados'>
                                    <Referenciados />
                                </ProtectedRoute>
                                <ProtectedRoute path='/pagoOperadores'>
                                    <Pagos />
                                </ProtectedRoute>
                                <ProtectedRoute path='/admin'>
                                    <Admin />
                                </ProtectedRoute>
                                <ProtectedRoute path='/liquidacionAdmin'>
                                    <LiquidacionAdmin />
                                </ProtectedRoute>
                                <ProtectedRoute path='/pagoAdmin'>
                                    <PagosAdmin />
                                </ProtectedRoute>
                                <ProtectedRoute path='/reporteUtilidad'>
                                    <ReporteUtilidad />
                                </ProtectedRoute>
                                <ProtectedRoute path='/gastosExtra'>
                                    <GastosExtra />
                                </ProtectedRoute>
                                <ProtectedRoute path='/Mantenimiento/:mttoId'>
                                    <Mantenimiento />
                                </ProtectedRoute>
                                <ProtectedRoute path='/Mantenimiento'>
                                    <Mantenimiento />
                                </ProtectedRoute>
                                <ProtectedRoute path='/password'>
                                    <Password />
                                </ProtectedRoute>
                                <ProtectedRoute path='/registroMateriales'>
                                    <RegistroMateriales />
                                </ProtectedRoute>
                                <ProtectedRoute path='/historialMtto'>
                                    <HistorialMtto />
                                </ProtectedRoute>
                                <ProtectedRoute path='/reporteMtto'>
                                    <ReporteMtto />
                                </ProtectedRoute>
                                <ProtectedRoute path='/'>
                                    <Home />
                                </ProtectedRoute>

                            </Switch>
                        </Grid>
                    </Grid>

                </div>
                <CssBaseline />
            </ThemeProvider>
        </>

    );
}
